import React from 'react'
import { makeStyles, TextField } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    input: {
        width: '100%',
        "& .MuiInput-underline:before": {
            borderBottomColor: "#FFFFFF80",
        },
        "& .MuiInputBase-input": {
            color: "#FFFFFF",
            fontSize: "20px",
            fontWeight: 200,
        },
        [theme.breakpoints.down('sm')]: {
            "& .MuiInputBase-input": {
                fontSize: "16px",
            },
        }
    },
}))

type InputProps = {
    value: string,
    setValue: (val: string) => void,
    placeholder?: string,
    type?: string
}

export default function CustomInput({ value, setValue, placeholder, type = "text" }: InputProps) {
    const classes = useStyles()

    return (
        <TextField
            variant="standard"
            placeholder={placeholder || ""}
            type={type}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className={classes.input}
            fullWidth
        />
    )
}
